import { Routes } from "@angular/router";
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { content } from "./shared/routes/routes";
import { LoginComponent } from "./auth/login/login.component";
import { AuthGuard } from "./shared/directive/auth.guard";
import { ForgotPasswordComponent } from "./auth/forgot-password/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./auth/reset-password/reset-password/reset-password.component";

export const routes: Routes = [
  {
    path: "auth/login",
    component: LoginComponent,
  },
  {
    path: "auth/forgot-password",
    component: ForgotPasswordComponent,
  },
  {
    path: "auth/reset-password/:token/:email",
    component: ResetPasswordComponent,
  },
  {
    path: "",
    component: ContentComponent,
    children: content,
    canActivate: [AuthGuard],
  },
  {
    path: "**",
    redirectTo: "error-page/error-400",
    pathMatch: "full",
  },
];
